export default (x: number | string): string => (typeof x === 'string' ? x : `${x * 8}px`);
